import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";

const GROUPS = [
  {
    title: "Telematics & IoT hardware",
    items: [
      { name: "Teltonika", src: "/partners/teltonika.png", bg: "bg-white" },
      { name: "Queclink", src: "/partners/queclink.png", bg: "bg-white" },
      { name: "Ruptela", src: "/partners/ruptela.png", bg: "bg-[#203466]", cover: true },
      { name: "Meitrack", src: "/partners/meitrack.png", bg: "bg-white" },
      { name: "Jimi IoT", src: "/partners/jimiiot.png", bg: "bg-[#0F1D33]" },
    ],
  },
  {
    title: "Video & CCTV",
    items: [
      { name: "Hikvision", src: "/partners/hikvision.png", bg: "bg-white" },
      { name: "Dahua", src: "/partners/dahua.svg", bg: "bg-[#0F1D33]" },
      { name: "Streamax", src: "/partners/streamax.png", bg: "bg-white" },
      { name: "Howen", src: "/partners/howen.webp", bg: "bg-white" },
    ],
  },
];

const Tile = ({ p }) => (
  <Item data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`} title={p.name}
    className={`flex h-24 items-center justify-center overflow-hidden rounded-xl border border-line px-6 transition-[transform,border-color] duration-300 hover:-translate-y-0.5 hover:border-cyan-400/50 ${p.bg}`}>
    {p.src ? (
      <img src={p.src} alt={`${p.name} logo`} loading="lazy" className={p.cover ? "h-full w-full object-cover" : "max-h-9 w-auto max-w-[80%] object-contain"} />
    ) : (
      <span className="font-heading text-xl font-bold tracking-tight text-navy">{p.name}</span>
    )}
  </Item>
);

export const Partners = () => (
  <section data-testid="partners-section" className="section relative bg-navy-900/50">
    <div className="wrap">
      <SectionHeading
        eyebrow="Technology ecosystem partners"
        title="Hardware and platforms we deploy."
        text="A selection of the established telematics, IoT and video technology brands Wexoz integrates. Selection is always driven by the customer's requirement — not by a single vendor relationship."
      />
      <div className="mt-14 space-y-10">
        {GROUPS.map((g) => (
          <div key={g.title}>
            <div className="eyebrow !text-slate-500">{g.title}</div>
            <Stagger className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" stagger={0.05}>
              {g.items.map((p) => <Tile key={p.name} p={p} />)}
            </Stagger>
          </div>
        ))}
      </div>
      <p className="mt-8 text-xs text-slate-500">All trademarks and logos are the property of their respective owners and are shown for identification only.</p>
    </div>
  </section>
);
